import Email from "./email";

const translations: Record<string, string> = {
  pt: 'Aguarde para novas exposições.',
  en: 'Wait for new exhibitions.'
}

const News: React.FC = () => {
  return (
    <div>
      <p>{translations[window.location.pathname.substring(1)] || translations['pt']}</p>
      <Email />
    </div>
  );
}

export default News;
